import { DesktopDateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { DateTime } from 'luxon';
import { useMemo } from 'react';
import { useFormFieldDef } from '../hooks/useFormFieldDef';

export const InstantFormField = ({ fieldDef }) => {
  const {
    value, // ISO string like '2025-04-03T21:27:28Z'
    setValue,
    onBlur,
    error,
    helperText,
    label,
    disabled,
    variant,
  } = useFormFieldDef(fieldDef);

  const localDateTime = useMemo(() => {
    if (!value) return null;
    return DateTime.fromISO(String(value), { zone: 'utc' }).toLocal();
  }, [value]);

  const handleChange = (newValue) => {
    if (!newValue || !newValue.isValid) {
      setValue(null);
      return;
    }
    const utc = newValue.toUTC().toISO(); // Save as UTC ISO string
    setValue(utc);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterLuxon}>
      <DesktopDateTimePicker
        disabled={disabled}
        label={label}
        value={localDateTime}
        onChange={handleChange}
        format="yyyy-LL-dd hh:mm:ss a"
        slotProps={{
          actionBar: {
            actions: ['clear'],
          },
          textField: {
            variant: variant,
            helperText,
            error,
            onBlur,
          },
        }}
      />
    </LocalizationProvider>
  );
};
